const ChipIcon = () => (
  <svg width="40" height="30" viewBox="0 0 40 30" fill="none">
    <rect
      x="2"
      y="2"
      width="36"
      height="26"
      rx="4"
      stroke="white"
      strokeWidth="1.5"
      opacity="0.8"
    />
    <line x1="10" y1="8" x2="30" y2="8" stroke="white" opacity="0.6" />
    <line x1="10" y1="12" x2="30" y2="12" stroke="white" opacity="0.6" />
    <line x1="10" y1="16" x2="30" y2="16" stroke="white" opacity="0.6" />
    <line x1="10" y1="20" x2="30" y2="20" stroke="white" opacity="0.6" />
  </svg>
);

const DeleteIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6h18" />
      <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </svg>
  );
};

const LoadingSpinner = () => {
  return (
    <svg
      className="animate-spin"
      width="24"
      height="24"
      fill="none"
      stroke="#e53e3e"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
    >
      <line x1="12" y1="2" x2="12" y2="6" />
      <line x1="12" y1="18" x2="12" y2="22" />
      <line x1="4.22" y1="4.22" x2="6.34" y2="6.34" />
      <line x1="17.66" y1="17.66" x2="19.78" y2="19.78" />
      <line x1="2" y1="12" x2="6" y2="12" />
      <line x1="18" y1="12" x2="22" y2="12" />
      <line x1="4.22" y1="19.78" x2="6.34" y2="17.66" />
      <line x1="17.66" y1="6.34" x2="19.78" y2="4.22" />
    </svg>
  );
};

const PaymentMethodCard = ({ savedCard, onDelete, isDeletingCard }) => {
  return (
    <div className="relative h-fit bg-gradient-to-br from-[#1e3a8a] via-[#2d348f] to-[#1e40af] rounded-2xl p-6 shadow-2xl aspect-auto flex flex-col justify-between">
      {/* Delete Button */}
      <button
        onClick={onDelete}
        disabled={isDeletingCard}
        className="absolute top-4 right-4 bg-white/20 hover:bg-white/30 rounded-full p-2 transition-all"
        aria-label="Delete card"
      >
        {isDeletingCard ? <LoadingSpinner /> : <DeleteIcon />}
      </button>

      {/* Card Content */}
      <div>
        {/* Chip */}
        <div className="mb-6">
          <ChipIcon />
        </div>

        {/* Card Number */}
        <div className="mb-4">
          <p className="text-white/70 text-xs mb-1">Card Number</p>
          <p className="text-white text-xl font-semibold tracking-wider">
            **** **** **** {savedCard.last4}
          </p>
        </div>

        {/* Expiry Date */}
        <div className="flex items-center justify-between">
          <div>
            <p className="text-white/70 text-xs mb-1">Expiry Date</p>
            <p className="text-white text-base font-medium">
              {savedCard.expMonth}/{savedCard.expYear}
            </p>
          </div>
          {/* Card Brand Logo */}
          <div className="flex justify-end">
            <h2 className="font-extrabold text-white italic uppercase text-3xl">
              {savedCard.displayBrand}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodCard;
